<template>
    <div id="app">
        <a-config-provider
            :locale="zhCN"
            :theme="{
                token: {
                    colorPrimary: themeData.colorPrimary,
                },
            }"
        >
            <a-layout>
                <SideMenu v-if="$route.meta.showSideMenu === true"></SideMenu>
                <a-layout>
                    <HeaderMenu v-if="$route.meta.showHeaderMenu === true"></HeaderMenu>
                    <a-layout-content>
                        <router-view />
                    </a-layout-content>
                </a-layout>
            </a-layout>
        </a-config-provider>
    </div>
</template>

<script setup>
import { ref, onBeforeMount, onMounted, onUnmounted } from "vue";
import HeaderMenu from "@/components/Menu/HeaderMenu.vue"; //导入组件 顶部
import SideMenu from "@/components/Menu/SideMenu.vue"; //导入组件 侧边
import zhCN from "ant-design-vue/lib/locale/zh_CN"; //组件导入中文
import dayjs from "dayjs"; //导入dayjs
import "dayjs/locale/zh-cn"; //日期导入中文
dayjs.locale("zh-cn");

const themeData = ref({
    colorPrimary: "#0083FF", // 默认主色
});

// 判断浏览器类型
const isFirefox = () => {
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("firefox") > -1) {
        document.documentElement.classList.add("firefox"); //火狐浏览器增加firefox
    }
};

// 监听localStorage变化，实现跨标签页登录状态同步
const handleStorageChange = (event) => {
    // 监听登录相关的localStorage变化
    const loginKeys = ['token', 'user_id', 'name', 'type', 'phone', 'isAdmin', 'status'];
    if (loginKeys.includes(event.key)) {
        // 当登录信息发生变化时，刷新页面以更新状态
        window.location.reload();
    }
};

onBeforeMount(() => {
    isFirefox(); //获取浏览器类型
});

onMounted(() => {
    // 添加localStorage变化监听器
    window.addEventListener('storage', handleStorageChange);
});

onUnmounted(() => {
    // 移除localStorage变化监听器，避免内存泄漏
    window.removeEventListener('storage', handleStorageChange);
});
</script>

<style lang="scss">
* {
    margin: 0;
    padding: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    height: 100vh;
    min-width: 1200px; /* 降低最小宽度要求，适配更多分辨率 */
    min-height: 750px;
    overflow-x: auto;
    background: #F5F7FD;
    background-image: url("@/assets/icons/images/background.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
}
/* 组件内容 */
.ant-layout{
    background: transparent;
}
.ant-layout .ant-layout-content {
    flex: auto;
    min-height: calc(750px - 66px);
    height: calc(100vh - 66px);
    padding: 0px 20px 20px 0px
}
/* 针对Firefox浏览器 */
.firefox * {
    scrollbar-width: thin; /* Firefox专用 */
    scrollbar-color: #d4d7de transparent; /* Firefox专用 */
}
</style>